const GOOGLE_DOMAINS_DATA = [
  {
    domain: 'google.ad',
    language_code: 'ca',
    country_code: 'ad',
    country_name: 'Andorra',
  },
  {
    domain: 'google.ae',
    language_code: 'ar',
    country_code: 'ae',
    country_name: 'United Arab Emirates',
  },
  {
    domain: 'google.al',
    language_code: 'sq',
    country_code: 'al',
    country_name: 'Albania',
  },
  {
    domain: 'google.am',
    language_code: 'hy',
    country_code: 'am',
    country_name: 'Armenia',
  },
  {
    domain: 'google.as',
    language_code: 'en',
    country_code: 'as',
    country_name: 'American Samoa',
  },
  {
    domain: 'google.at',
    language_code: 'de',
    country_code: 'at',
    country_name: 'Austria',
  },
  {
    domain: 'google.az',
    language_code: 'az',
    country_code: 'az',
    country_name: 'Azerbaijan',
  },
  {
    domain: 'google.ba',
    language_code: 'bs',
    country_code: 'ba',
    country_name: 'Bosnia and Herzegovina',
  },
  {
    domain: 'google.be',
    language_code: 'nl',
    country_code: 'be',
    country_name: 'Belgium',
  },
  {
    domain: 'google.bf',
    language_code: 'fr',
    country_code: 'bf',
    country_name: 'Burkina Faso',
  },
  {
    domain: 'google.bg',
    language_code: 'bg',
    country_code: 'bg',
    country_name: 'Bulgaria',
  },
  {
    domain: 'google.bi',
    language_code: 'fr',
    country_code: 'bi',
    country_name: 'Burundi',
  },
  {
    domain: 'google.bj',
    language_code: 'fr',
    country_code: 'bj',
    country_name: 'Benin',
  },
  {
    domain: 'google.bs',
    language_code: 'en',
    country_code: 'bs',
    country_name: 'Bahamas',
  },
  {
    domain: 'google.bt',
    language_code: 'bt',
    country_code: 'bt',
    country_name: 'Bhutan',
  },
  {
    domain: 'google.by',
    language_code: 'be',
    country_code: 'by',
    country_name: 'Belarus',
  },
  {
    domain: 'google.ca',
    language_code: 'en',
    country_code: 'ca',
    country_name: 'Canada',
  },
  {
    domain: 'google.cd',
    language_code: 'fr',
    country_code: 'cg',
    country_name: 'Democratic Republic of the Congo',
  },
  {
    domain: 'google.cf',
    language_code: 'fr',
    country_code: 'cf',
    country_name: 'Central African Republic',
  },
  {
    domain: 'google.cg',
    language_code: 'fr',
    country_code: 'cg',
    country_name: 'Republic of the Congo',
  },
  {
    domain: 'google.ch',
    language_code: 'de',
    country_code: 'ch',
    country_name: 'Switzerland',
  },
  {
    domain: 'google.ci',
    language_code: 'fr',
    country_code: 'ci',
    country_name: 'Ivory Coast',
  },
  {
    domain: 'google.cl',
    language_code: 'es',
    country_code: 'cl',
    country_name: 'Chile',
  },
  {
    domain: 'google.cm',
    language_code: 'en',
    country_code: 'cm',
    country_name: 'Cameroon',
  },
  {
    domain: 'google.co.ao',
    language_code: 'pt',
    country_code: 'ao',
    country_name: 'Angola',
  },
  {
    domain: 'google.co.bw',
    language_code: 'en',
    country_code: 'bw',
    country_name: 'Botswana',
  },
  {
    domain: 'google.co.ck',
    language_code: 'en',
    country_code: 'ck',
    country_name: 'Cook Islands',
  },
  {
    domain: 'google.co.cr',
    language_code: 'es',
    country_code: 'cr',
    country_name: 'Costa Rica',
  },
  {
    domain: 'google.co.id',
    language_code: 'id',
    country_code: 'id',
    country_name: 'Indonesia',
  },
  {
    domain: 'google.co.il',
    language_code: 'iw',
    country_code: 'il',
    country_name: 'Israel',
  },
  {
    domain: 'google.co.in',
    language_code: 'hi',
    country_code: 'in',
    country_name: 'India',
  },
  {
    domain: 'google.co.jp',
    language_code: 'ja',
    country_code: 'jp',
    country_name: 'Japan',
  },
  {
    domain: 'google.co.ke',
    language_code: 'en',
    country_code: 'ke',
    country_name: 'Kenya',
  },
  {
    domain: 'google.co.kr',
    language_code: 'ko',
    country_code: 'kr',
    country_name: 'South Korea',
  },
  {
    domain: 'google.co.ls',
    language_code: 'en',
    country_code: 'ls',
    country_name: 'Lesotho',
  },
  {
    domain: 'google.co.ma',
    language_code: 'ar',
    country_code: 'ma',
    country_name: 'Morocco',
  },
  {
    domain: 'google.co.mz',
    language_code: 'pt',
    country_code: 'mz',
    country_name: 'Mozambique',
  },
  {
    domain: 'google.co.nz',
    language_code: 'en',
    country_code: 'nz',
    country_name: 'New Zealand',
  },
  {
    domain: 'google.co.th',
    language_code: 'th',
    country_code: 'th',
    country_name: 'Thailand',
  },
  {
    domain: 'google.co.tz',
    language_code: 'sw',
    country_code: 'tz',
    country_name: 'Tanzania',
  },
  {
    domain: 'google.co.ug',
    language_code: 'en',
    country_code: 'ug',
    country_name: 'Uganda',
  },
  {
    domain: 'google.co.uk',
    language_code: 'en',
    country_code: 'uk',
    country_name: 'United Kingdom',
  },
  {
    domain: 'google.co.uz',
    language_code: 'uz',
    country_code: 'uz',
    country_name: 'Uzbekistan',
  },
  {
    domain: 'google.co.ve',
    language_code: 'es',
    country_code: 've',
    country_name: 'Venezuela',
  },
  {
    domain: 'google.co.vi',
    language_code: 'en',
    country_code: 'vi',
    country_name: 'United States Virgin Islands',
  },
  {
    domain: 'google.co.za',
    language_code: 'af',
    country_code: 'za',
    country_name: 'South Africa',
  },
  {
    domain: 'google.co.zm',
    language_code: 'en',
    country_code: 'zm',
    country_name: 'Zambia',
  },
  {
    domain: 'google.co.zw',
    language_code: 'en',
    country_code: 'zw',
    country_name: 'Zimbabwe',
  },
  {
    domain: 'google.com',
    language_code: 'en',
    country_code: 'us',
    country_name: 'United States',
  },
  {
    domain: 'google.com.af',
    language_code: 'ps',
    country_code: 'af',
    country_name: 'Afghanistan',
  },
  {
    domain: 'google.com.ag',
    language_code: 'en',
    country_code: 'ag',
    country_name: 'Antigua and Barbuda',
  },
  {
    domain: 'google.com.ai',
    language_code: 'en',
    country_code: 'ai',
    country_name: 'Anguilla',
  },
  {
    domain: 'google.com.ar',
    language_code: 'es',
    country_code: 'ar',
    country_name: 'Argentina',
  },
  {
    domain: 'google.com.au',
    language_code: 'en',
    country_code: 'au',
    country_name: 'Australia',
  },
  {
    domain: 'google.com.bd',
    language_code: 'bn',
    country_code: 'bd',
    country_name: 'Bangladesh',
  },
  {
    domain: 'google.com.bh',
    language_code: 'ar',
    country_code: 'bh',
    country_name: 'Bahrain',
  },
  {
    domain: 'google.com.bn',
    language_code: 'ms',
    country_code: 'bn',
    country_name: 'Brunei',
  },
  {
    domain: 'google.com.bo',
    language_code: 'es',
    country_code: 'bo',
    country_name: 'Bolivia',
  },
  {
    domain: 'google.com.br',
    language_code: 'pt',
    country_code: 'br',
    country_name: 'Brazil',
  },
  {
    domain: 'google.com.bz',
    language_code: 'en',
    country_code: 'bz',
    country_name: 'Belize',
  },
  {
    domain: 'google.com.co',
    language_code: 'es',
    country_code: 'co',
    country_name: 'Colombia',
  },
  {
    domain: 'google.com.cu',
    language_code: 'es',
    country_code: 'cu',
    country_name: 'Cuba',
  },
  {
    domain: 'google.com.cy',
    language_code: 'el',
    country_code: 'cy',
    country_name: 'Cyprus',
  },
  {
    domain: 'google.com.do',
    language_code: 'es',
    country_code: 'do',
    country_name: 'Dominican Republic',
  },
  {
    domain: 'google.com.ec',
    language_code: 'es',
    country_code: 'ec',
    country_name: 'Ecuador',
  },
  {
    domain: 'google.com.eg',
    language_code: 'ar',
    country_code: 'eg',
    country_name: 'Egypt',
  },
  {
    domain: 'google.com.et',
    language_code: 'am',
    country_code: 'et',
    country_name: 'Ethiopia',
  },
  {
    domain: 'google.com.fj',
    language_code: 'en',
    country_code: 'fj',
    country_name: 'Fiji',
  },
  {
    domain: 'google.com.gh',
    language_code: 'en',
    country_code: 'gh',
    country_name: 'Ghana',
  },
  {
    domain: 'google.com.gi',
    language_code: 'en',
    country_code: 'gi',
    country_name: 'Gibraltar',
  },
  {
    domain: 'google.com.gt',
    language_code: 'es',
    country_code: 'gt',
    country_name: 'Guatemala',
  },
  {
    domain: 'google.com.hk',
    language_code: 'en',
    country_code: 'hk',
    country_name: 'Hong Kong',
  },
  {
    domain: 'google.com.jm',
    language_code: 'en',
    country_code: 'jm',
    country_name: 'Jamaica',
  },
  {
    domain: 'google.com.kh',
    language_code: 'km',
    country_code: 'kh',
    country_name: 'Cambodia',
  },
  {
    domain: 'google.com.kw',
    language_code: 'ar',
    country_code: 'kw',
    country_name: 'Kuwait',
  },
  {
    domain: 'google.com.lb',
    language_code: 'ar',
    country_code: 'lb',
    country_name: 'Lebanon',
  },
  {
    domain: 'google.com.ly',
    language_code: 'ar',
    country_code: 'ly',
    country_name: 'Libya',
  },
  {
    domain: 'google.com.mm',
    language_code: 'my',
    country_code: 'mm',
    country_name: 'Myanmar',
  },
  {
    domain: 'google.com.mt',
    language_code: 'mt',
    country_code: 'mt',
    country_name: 'Malta',
  },
  {
    domain: 'google.com.mx',
    language_code: 'es',
    country_code: 'mx',
    country_name: 'Mexico',
  },
  {
    domain: 'google.com.my',
    language_code: 'ms',
    country_code: 'my',
    country_name: 'Malaysia',
  },
  {
    domain: 'google.com.na',
    language_code: 'en',
    country_code: 'na',
    country_name: 'Namibia',
  },
  {
    domain: 'google.com.ng',
    language_code: 'en',
    country_code: 'ng',
    country_name: 'Nigeria',
  },
  {
    domain: 'google.com.ni',
    language_code: 'es',
    country_code: 'ni',
    country_name: 'Nicaragua',
  },
  {
    domain: 'google.com.np',
    language_code: 'ne',
    country_code: 'np',
    country_name: 'Nepal',
  },
  {
    domain: 'google.com.om',
    language_code: 'ar',
    country_code: 'om',
    country_name: 'Oman',
  },
  {
    domain: 'google.com.pa',
    language_code: 'es',
    country_code: 'pa',
    country_name: 'Panama',
  },
  {
    domain: 'google.com.pe',
    language_code: 'es',
    country_code: 'pe',
    country_name: 'Peru',
  },
  {
    domain: 'google.com.pg',
    language_code: 'en',
    country_code: 'pg',
    country_name: 'Papua New Guinea',
  },
  {
    domain: 'google.com.ph',
    language_code: 'tl',
    country_code: 'ph',
    country_name: 'Philippines',
  },
  {
    domain: 'google.com.pk',
    language_code: 'en',
    country_code: 'pk',
    country_name: 'Pakistan',
  },
  {
    domain: 'google.com.pr',
    language_code: 'es',
    country_code: 'pr',
    country_name: 'Puerto Rico',
  },
  {
    domain: 'google.com.py',
    language_code: 'es',
    country_code: 'py',
    country_name: 'Paraguay',
  },
  {
    domain: 'google.com.qa',
    language_code: 'ar',
    country_code: 'qa',
    country_name: 'Qatar',
  },
  {
    domain: 'google.com.sa',
    language_code: 'ar',
    country_code: 'sa',
    country_name: 'Saudi Arabia',
  },
  {
    domain: 'google.com.sb',
    language_code: 'en',
    country_code: 'sb',
    country_name: 'Solomon Islands',
  },
  {
    domain: 'google.com.sg',
    language_code: 'en',
    country_code: 'sg',
    country_name: 'Singapore',
  },
  {
    domain: 'google.com.sl',
    language_code: 'en',
    country_code: 'sl',
    country_name: 'Sierra Leone',
  },
  {
    domain: 'google.com.sv',
    language_code: 'es',
    country_code: 'sv',
    country_name: 'El Salvador',
  },
  {
    domain: 'google.com.tj',
    language_code: 'tg',
    country_code: 'tj',
    country_name: 'Tajikistan',
  },
  {
    domain: 'google.com.tr',
    language_code: 'tr',
    country_code: 'tr',
    country_name: 'Turkiye',
  },
  {
    domain: 'google.com.tr',
    language_code: 'tr',
    country_code: 'tr',
    country_name: 'Turkey',
  },
  {
    domain: 'google.com.tw',
    language_code: 'zh-tw',
    country_code: 'tw',
    country_name: 'Taiwan',
  },
  {
    domain: 'google.com.ua',
    language_code: 'uk',
    country_code: 'ua',
    country_name: 'Ukraine',
  },
  {
    domain: 'google.com.uy',
    language_code: 'es',
    country_code: 'uy',
    country_name: 'Uruguay',
  },
  {
    domain: 'google.com.vc',
    language_code: 'en',
    country_code: 'vc',
    country_name: 'Saint Vincent and the Grenadines',
  },
  {
    domain: 'google.com.vn',
    language_code: 'vi',
    country_code: 'vn',
    country_name: 'Vietnam',
  },
  {
    domain: 'google.cv',
    language_code: 'pt',
    country_code: 'cv',
    country_name: 'Cape Verde',
  },
  {
    domain: 'google.cz',
    language_code: 'cs',
    country_code: 'cz',
    country_name: 'Czech Republic',
  },
  {
    domain: 'google.de',
    language_code: 'de',
    country_code: 'de',
    country_name: 'Germany',
  },
  {
    domain: 'google.dj',
    language_code: 'ar',
    country_code: 'dj',
    country_name: 'Djibouti',
  },
  {
    domain: 'google.dk',
    language_code: 'da',
    country_code: 'dk',
    country_name: 'Denmark',
  },
  {
    domain: 'google.dm',
    language_code: 'en',
    country_code: 'dm',
    country_name: 'Dominica',
  },
  {
    domain: 'google.dz',
    language_code: 'ar',
    country_code: 'dz',
    country_name: 'Algeria',
  },
  {
    domain: 'google.ee',
    language_code: 'et',
    country_code: 'ee',
    country_name: 'Estonia',
  },
  {
    domain: 'google.es',
    language_code: 'es',
    country_code: 'es',
    country_name: 'Spain',
  },
  {
    domain: 'google.fi',
    language_code: 'fi',
    country_code: 'fi',
    country_name: 'Finland',
  },
  {
    domain: 'google.fm',
    language_code: 'en',
    country_code: 'fm',
    country_name: 'Micronesia, Federated States of',
  },
  {
    domain: 'google.fr',
    language_code: 'fr',
    country_code: 'fr',
    country_name: 'France',
  },
  {
    domain: 'google.ga',
    language_code: 'fr',
    country_code: 'ga',
    country_name: 'Gabon',
  },
  {
    domain: 'google.ge',
    language_code: 'ka',
    country_code: 'ge',
    country_name: 'Georgia',
  },
  {
    domain: 'google.gl',
    language_code: 'kl',
    country_code: 'gl',
    country_name: 'Greenland',
  },
  {
    domain: 'google.gm',
    language_code: 'en',
    country_code: 'gm',
    country_name: 'Gambia',
  },
  {
    domain: 'google.gp',
    language_code: 'fr',
    country_code: 'gp',
    country_name: 'Guadeloupe',
  },
  {
    domain: 'google.gr',
    language_code: 'el',
    country_code: 'gr',
    country_name: 'Greece',
  },
  {
    domain: 'google.gy',
    language_code: 'en',
    country_code: 'gy',
    country_name: 'Guyana',
  },
  {
    domain: 'google.hn',
    language_code: 'es',
    country_code: 'hn',
    country_name: 'Honduras',
  },
  {
    domain: 'google.hr',
    language_code: 'hr',
    country_code: 'hr',
    country_name: 'Croatia',
  },
  {
    domain: 'google.ht',
    language_code: 'fr',
    country_code: 'ht',
    country_name: 'Haiti',
  },
  {
    domain: 'google.hu',
    language_code: 'hu',
    country_code: 'hu',
    country_name: 'Hungary',
  },
  {
    domain: 'google.ie',
    language_code: 'en',
    country_code: 'ie',
    country_name: 'Ireland',
  },
  {
    domain: 'google.iq',
    language_code: 'ar',
    country_code: 'iq',
    country_name: 'Iraq',
  },
  {
    domain: 'google.is',
    language_code: 'is',
    country_code: 'is',
    country_name: 'Iceland',
  },
  {
    domain: 'google.it',
    language_code: 'it',
    country_code: 'it',
    country_name: 'Italy',
  },
  {
    domain: 'google.je',
    language_code: 'en',
    country_code: 'je',
    country_name: 'Jersey',
  },
  {
    domain: 'google.jo',
    language_code: 'ar',
    country_code: 'jo',
    country_name: 'Jordan',
  },
  {
    domain: 'google.kg',
    language_code: 'ky',
    country_code: 'kg',
    country_name: 'Kyrgyzstan',
  },
  {
    domain: 'google.ki',
    language_code: 'en',
    country_code: 'ki',
    country_name: 'Kiribati',
  },
  {
    domain: 'google.kz',
    language_code: 'kk',
    country_code: 'kz',
    country_name: 'Kazakhstan',
  },
  {
    domain: 'google.la',
    language_code: 'lo',
    country_code: 'la',
    country_name: 'Laos',
  },
  {
    domain: 'google.li',
    language_code: 'de',
    country_code: 'li',
    country_name: 'Liechtenstein',
  },
  {
    domain: 'google.lk',
    language_code: 'si',
    country_code: 'lk',
    country_name: 'Sri Lanka',
  },
  {
    domain: 'google.lt',
    language_code: 'lt',
    country_code: 'lt',
    country_name: 'Lithuania',
  },
  {
    domain: 'google.lu',
    language_code: 'fr',
    country_code: 'lu',
    country_name: 'Luxembourg',
  },
  {
    domain: 'google.lv',
    language_code: 'lv',
    country_code: 'lv',
    country_name: 'Latvia',
  },
  {
    domain: 'google.md',
    language_code: 'ro',
    country_code: 'md',
    country_name: 'Moldova',
  },
  {
    domain: 'google.mg',
    language_code: 'fr',
    country_code: 'mg',
    country_name: 'Madagascar',
  },
  {
    domain: 'google.mk',
    language_code: 'mk',
    country_code: 'mk',
    country_name: 'Macedonia',
  },
  {
    domain: 'google.ml',
    language_code: 'fr',
    country_code: 'ml',
    country_name: 'Mali',
  },
  {
    domain: 'google.mn',
    language_code: 'mn',
    country_code: 'mn',
    country_name: 'Mongolia',
  },
  {
    domain: 'google.ms',
    language_code: 'en',
    country_code: 'ms',
    country_name: 'Montserrat',
  },
  {
    domain: 'google.mu',
    language_code: 'en',
    country_code: 'mu',
    country_name: 'Mauritius',
  },
  {
    domain: 'google.mv',
    language_code: 'mv',
    country_code: 'mv',
    country_name: 'Maldives',
  },
  {
    domain: 'google.mw',
    language_code: 'en',
    country_code: 'mw',
    country_name: 'Malawi',
  },
  {
    domain: 'google.ne',
    language_code: 'fr',
    country_code: 'ne',
    country_name: 'Niger',
  },
  {
    domain: 'google.nl',
    language_code: 'nl',
    country_code: 'nl',
    country_name: 'Netherlands',
  },
  {
    domain: 'google.no',
    language_code: 'no',
    country_code: 'no',
    country_name: 'Norway',
  },
  {
    domain: 'google.nr',
    language_code: 'en',
    country_code: 'nr',
    country_name: 'Nauru',
  },
  {
    domain: 'google.nu',
    language_code: 'en',
    country_code: 'nu',
    country_name: 'Niue',
  },
  {
    domain: 'google.pl',
    language_code: 'pl',
    country_code: 'pl',
    country_name: 'Poland',
  },
  {
    domain: 'google.ps',
    language_code: 'ar',
    country_code: 'ps',
    country_name: 'Palestine',
  },
  {
    domain: 'google.pt',
    language_code: 'pt',
    country_code: 'pt',
    country_name: 'Portugal',
  },
  {
    domain: 'google.ro',
    language_code: 'ro',
    country_code: 'ro',
    country_name: 'Romania',
  },
  {
    domain: 'google.rs',
    language_code: 'sr',
    country_code: 'rs',
    country_name: 'Serbia',
  },
  {
    domain: 'google.ru',
    language_code: 'ru',
    country_code: 'ru',
    country_name: 'Russia',
  },
  {
    domain: 'google.rw',
    language_code: 'rw',
    country_code: 'rw',
    country_name: 'Rwanda',
  },
  {
    domain: 'google.sc',
    language_code: 'fr',
    country_code: 'sc',
    country_name: 'Seychelles',
  },
  {
    domain: 'google.se',
    language_code: 'sv',
    country_code: 'se',
    country_name: 'Sweden',
  },
  {
    domain: 'google.sh',
    language_code: 'en',
    country_code: 'sh',
    country_name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    domain: 'google.si',
    language_code: 'sl',
    country_code: 'si',
    country_name: 'Slovenia',
  },
  {
    domain: 'google.sk',
    language_code: 'sk',
    country_code: 'sk',
    country_name: 'Slovakia',
  },
  {
    domain: 'google.sm',
    language_code: 'it',
    country_code: 'sm',
    country_name: 'San Marino',
  },
  {
    domain: 'google.sn',
    language_code: 'fr',
    country_code: 'sn',
    country_name: 'Senegal',
  },
  {
    domain: 'google.so',
    language_code: 'so',
    country_code: 'so',
    country_name: 'Somalia',
  },
  {
    domain: 'google.sr',
    language_code: 'nl',
    country_code: 'sr',
    country_name: 'Suriname',
  },
  {
    domain: 'google.td',
    language_code: 'ar',
    country_code: 'td',
    country_name: 'Chad',
  },
  {
    domain: 'google.tg',
    language_code: 'fr',
    country_code: 'tg',
    country_name: 'Togo',
  },
  {
    domain: 'google.tk',
    language_code: 'en',
    country_code: 'tk',
    country_name: 'Tokelau',
  },
  {
    domain: 'google.tl',
    language_code: 'pt',
    country_code: 'tl',
    country_name: 'Timor-Leste',
  },
  {
    domain: 'google.tm',
    language_code: 'tk',
    country_code: 'tm',
    country_name: 'Turkmenistan',
  },
  {
    domain: 'google.tn',
    language_code: 'ar',
    country_code: 'tn',
    country_name: 'Tunisia',
  },
  {
    domain: 'google.to',
    language_code: 'en',
    country_code: 'to',
    country_name: 'Tonga',
  },
  {
    domain: 'google.tt',
    language_code: 'en',
    country_code: 'tt',
    country_name: 'Trinidad and Tobago',
  },
  {
    domain: 'google.vg',
    language_code: 'en',
    country_code: 'vg',
    country_name: 'British Virgin Islands',
  },
  {
    domain: 'google.vu',
    language_code: 'vu',
    country_code: 'vu',
    country_name: 'Vanuatu',
  },
  {
    domain: 'google.ws',
    language_code: 'ws',
    country_code: 'ws',
    country_name: 'Samoa',
  },
]

export default GOOGLE_DOMAINS_DATA
